import Backbone from '@rover/globals/backbone';
import Rover from '@rover/globals/Rover';

const PAYMENT_METHOD_SORT_ORDER = ['promo', 'wallet'];

export default Backbone.Model.extend({
  sortOrder: PAYMENT_METHOD_SORT_ORDER.indexOf('wallet'),
  url() {
    return this.get('url');
  },
  defaults: {
    non_redeemable: null,
    redeemable: null,
  },
  getTotalRoverBucks() {
    if (this.get('non_redeemable') === null || this.get('redeemable') === null) {
      return '0.00';
    }
    return (parseFloat(this.get('non_redeemable')) + parseFloat(this.get('redeemable'))).toFixed(2);
  },
});



// WEBPACK FOOTER //
// ./js/backbone/models/WalletMethodModel.js